import React from "react";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import { toEditorState } from "../components/OptionForm";
import { connect } from 'react-redux';
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";
import {
  saveNote,
  deleteNote
} from "../actions/userEdits";

const editorStyle = {
  height: 300,
  padding: 10,
  border: "1px solid #efefef"
};

class UserNotesModal extends React.Component {

  state = {
    notesState: EditorState.createEmpty()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.response && this.props.optionID !== prevProps.optionID) {
      let note = (this.props.response.userEdits.userNotes && this.props.response.userEdits.userNotes[this.props.optionID]) ? this.props.response.userEdits.userNotes[this.props.optionID] : ""
      this.setState({notesState: toEditorState(note)});
    }
  }

  render() {
    const { open, readOnly } = this.props;
    return (
      <Dialog
        modal={true}
        open={open}
        autoScrollBodyContent={true}
        title="Notes"
        actions={[
          <FlatButton
            label={readOnly ? "Close" : "Cancel"}
            onClick={this.handleRequestUserNotesClose}
          />,
          !readOnly && (
            <RaisedButton
              onClick={this.handleSaveUserNotes}
              primary={true}
              label="Save"
            />
          )
        ]}
      >
      <div style={{
        fontStyle: 'italic',
        marginBottom: 16,
        fontSize: 18,
        fontWeight: "500",
        color: "#404040"
      }}>{this.props.optionTitle}</div>
        {this.props.open && (
          <div>
            <Editor
              editorStyle={editorStyle}
              editorState={this.state.notesState}
              wrapperClassName="wrapper"
              editorClassName="editor"
              onEditorStateChange={this.handleEditorStateChange}
            />
          </div>
        )}
      </Dialog>
    );
  }

  handleEditorStateChange = notesState => {
    if (!this.props.readOnly) {
      this.setState({
        notesState
      });
    }
  };

  handleSaveUserNotes = () => {
    let optionID = this.props.optionID;
    let notesEditor = this.state.notesState;
    let hasText = notesEditor.getCurrentContent().hasText();
    let notes = draftToHtml(convertToRaw(notesEditor.getCurrentContent()));
    this.handleRequestUserNotesClose();

    if (hasText) {
      this.props.saveNote(optionID, notes, this.props.response.metadata.id);
    } else {
      //TODO: could optimize by only deleting if already a note, would need to pass flag or some way of determining
      this.props.deleteNote(optionID, this.props.response.metadata.id);
    }
  };

  handleRequestUserNotesClose = () => {
    this.setState({
      notesState: EditorState.createEmpty()
    });
    this.props.onRequestClose();
  };


}

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveNote: (optionID, notes, responseID) => dispatch(saveNote(optionID, notes, responseID)),
    deleteNote: (optionID, responseID) => dispatch(deleteNote(optionID, responseID))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserNotesModal);
